import React from 'react'
import { get } from 'lodash'
import { Controller, Control, useFormContext } from 'react-hook-form'
import { TextInput } from 'components/ui'
import { regExLinkRecognizer } from 'constants/baseValues'
import useLocaleText from 'components/useLocaleText'

interface LinkInputFieldProps {
  name: string
  control: Control
  placeholder: string
  defaultValue?: string
}

export const LinkInputField: React.FC<LinkInputFieldProps> = ({ name, control, placeholder, defaultValue }) => {
  const validationMessage = useLocaleText('t_link_st_error')
  const { errors } = useFormContext()
  const isInvalid = !!get(errors, name)

  return (
    <Controller
      as={TextInput}
      name={name}
      id={name}
      control={control}
      placeholder={placeholder}
      rules={{
        required: validationMessage,
        pattern: {
          value: regExLinkRecognizer,
          message: validationMessage,
        },
      }}
      key={name}
      elementHeight="40px"
      isInvalid={isInvalid}
      errorMessage={validationMessage}
      maxLength={150}
      defaultValue={defaultValue}
    />
  )
}
